document.addEventListener('DOMContentLoaded', function () {
  window.sr = ScrollReveal({
    duration: 800,
    origin: 'bottom',
    distance: '25px',
    scale: 0.85,
  });

  // Perf 07/10/2026 : cartes du haut de grille (.nk-sr-top), deja visibles avant le JS.
  // Celles qui sont dans l'ecran au chargement restent fixes ; les autres retrouvent l'animation habituelle.
  document.querySelectorAll('.product-card-wrapper.nk-sr-top').forEach(function (el) {
    var r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) {
      el.classList.remove('sr-animate');
      el.classList.add('nk-sr-skip');
    }
    el.classList.remove('nk-sr-top');
  });

  sr.reveal('.product-card-wrapper:not(.nk-sr-skip)', { interval: 100 });
  sr.reveal('.collection-card', { interval: 100 });
  sr.reveal('.article-card-wrapper', { interval: 100 });
  sr.reveal('.sr-animate--no-interval');
});
